import { render, staticRenderFns } from "./FolderView.vue?vue&type=template&id=43b21cf4&scoped=true&"
import script from "./FolderView.vue?vue&type=script&lang=js&"
export * from "./FolderView.vue?vue&type=script&lang=js&"
import style0 from "./FolderView.vue?vue&type=style&index=0&id=43b21cf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b21cf4",
  null
  
)

export default component.exports